import React, { lazy, Suspense } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { addProject } from "./components/Redux/Actions/ProjectAction";
import Error from "./components/error/error";
import Spinner from "react-bootstrap/Spinner";
import ProfileImage from "./components/profile_image";
import Certificates from "./components/certificates/certificates";
import Recommendation from "./components/recommendation/recommendation";

const Banner = lazy(() => import("./components/banner/banner"));
const Resume = lazy(() => import("./components/resume/resume"));
const Award = lazy(() => import("./components/award/award"));
const ShowProject = lazy(() => import("./components/project/showProject"));
const FullProject = lazy(() => import("./components/project/fullProjects"));
const SkillsPage = lazy(() => import("./components/skills/SkillsPage"));
const PortfolioAssistant = lazy(
  () => import("./components/portfolioAssistant/portfolioAssistant"),
);

const assistantMode = process.env.REACT_APP_ASSISTANT_MODE || "fallback";

export default function Routing() {
  const project = useSelector((state) => state.projectProducts.project.name);
  const projects = JSON.parse(localStorage.getItem("project"));
  const dispatch = useDispatch();

  useEffect(() => {
    if (projects) {
      dispatch(addProject(projects));
    }
  }, [dispatch, projects]);

  const spin = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner animation="grow" variant="primary" />
      </div>
    );
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={spin()}>
            <Banner />
          </Suspense>
        }
      />
      <Route
        path="/resume"
        element={
          <Suspense fallback={spin()}>
            <Resume />
          </Suspense>
        }
      />
      <Route
        path="/project"
        element={
          <Suspense fallback={spin()}>
            <FullProject />
          </Suspense>
        }
      />
      <Route
        path="/skills"
        element={
          <Suspense fallback={spin()}>
            <SkillsPage />
          </Suspense>
        }
      />
      <Route
        path="/awards"
        element={
          <Suspense fallback={spin()}>
            <Award />
          </Suspense>
        }
      />
      <Route
        path="/certifications"
        element={
          <Suspense fallback={spin()}>
            <Certificates />
          </Suspense>
        }
      />
      <Route
        path="/recommendations"
        element={
          <Suspense fallback={spin()}>
            <Recommendation />
          </Suspense>
        }
      />
      <Route
        path={`/${project}`}
        element={
          <Suspense fallback={spin()}>
            <ShowProject />
          </Suspense>
        }
      />
      <Route path={"/mohanrajProfileImage"} element={<ProfileImage />} />
      <Route
        path="/assistant"
        element={
          <Suspense fallback={spin()}>
            <PortfolioAssistant assistantMode={assistantMode} />
          </Suspense>
        }
      />
      <Route path="*" element={<Error />} />
    </Routes>
  );
}
